
import { useState } from 'react';

const SocialFloat = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const socialLinks = [
    {
      name: 'Instagram',
      icon: 'ri-instagram-line',
      url: 'https://instagram.com',
      color: 'bg-gradient-to-br from-purple-500 to-pink-500',
      hoverColor: 'hover:from-purple-600 hover:to-pink-600'
    },
    {
      name: 'Facebook',
      icon: 'ri-facebook-line',
      url: 'https://facebook.com',
      color: 'bg-blue-600',
      hoverColor: 'hover:bg-blue-700'
    },
    {
      name: 'YouTube',
      icon: 'ri-youtube-line',
      url: 'https://youtube.com',
      color: 'bg-red-600',
      hoverColor: 'hover:bg-red-700'
    },
    {
      name: 'WhatsApp',
      icon: 'ri-whatsapp-line',
      url: 'https://whatsapp.com',
      color: 'bg-green-500',
      hoverColor: 'hover:bg-green-600'
    }
  ];

  return (
    <div className="fixed right-6 top-1/2 transform -translate-y-1/2 z-50">
      <div className="flex flex-col items-center space-y-3">
        {/* Social Links */}
        <div className={`flex flex-col space-y-3 transition-all duration-500 ${
          isExpanded ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8 pointer-events-none'
        }`}>
          {socialLinks.map((social, index) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-12 h-12 ${social.color} ${social.hoverColor} text-white rounded-full flex items-center justify-center shadow-lg transition-all duration-300 transform hover:scale-110 hover:shadow-xl`}
              style={{ transitionDelay: `${index * 50}ms` }}
              title={social.name}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${social.icon} text-lg`}></i>
              </div>
            </a>
          ))}
        </div>

        {/* Toggle Button */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={`w-14 h-14 bg-gradient-to-br from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white rounded-full flex items-center justify-center shadow-lg transition-all duration-300 transform hover:scale-110 hover:shadow-xl ${
            isExpanded ? 'rotate-45' : 'rotate-0'
          }`}
          title="Social Media"
        >
          <div className="w-6 h-6 flex items-center justify-center">
            <i className={`${isExpanded ? 'ri-close-line' : 'ri-share-line'} text-xl`}></i>
          </div>
        </button>
      </div>
    </div>
  );
};

export default SocialFloat;
